import { assign } from 'xstate5';

import { type ReorderEventParams, type ReorderMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const storeDeliveryDetails: ReorderMachineAction<ReorderEventParams> = assign(
  (_args, params) => ({
    deliveryAddressName: params.reorderEvent.deliveryAddressName ?? '',
    deliveryOrderDetail: params.reorderEvent.deliveryOrderDetail,
  }),
);
